import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import { TrackingResponse } from "../../../../hooks/morning/usePostTrackingList";
import Button from "./common/Button";
import CheckBox from "./common/Checkbox";
import ModifyTracking from "./ModifyTracking";
import Input from "./common/Input";
import { useGetTrackingAddPrint } from "../../../../hooks/morning/useGetTrackingAddPrint";
import { usePostTrackingAddPrint } from "../../../../hooks/morning/usePostTrackingAddPrint";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { ReactComponent as Notice } from "assets/morning/icon/notice.svg";
import { ReactComponent as Memo } from "assets/morning/icon/memo.svg";
import { ReactComponent as PageBefore } from "assets/morning/icon/pageBefore.svg";
import { ReactComponent as PageFirst } from "assets/morning/icon/pageFirst.svg";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import { ReactComponent as MemoOn } from "assets/morning/icon/memoOn.svg";
import { ReactComponent as RightArrow } from "assets/morning/icon/rightArrow.svg";
import { ReactComponent as ArrowDown } from "assets/morning/icon/arrowDownNavy.svg";
import PrintTracking from "./PrintTracking";
import { TrackingRequest } from "../../../../hooks/morning/usePostTrackingPopPrint";
import { useMorningAuthStore } from "../../../../store/useMorningAuthStore";
import { usePostTrackingAddNextPrint } from "../../../../hooks/morning/usePostTrackingAddNextPrint";
import toast, { Toaster } from "react-hot-toast";
import { toastErrorSyle } from "hooks/utils/util";
import { useGetMypageInfo } from "hooks/morning/useGetMypageInfo";
import { useMasterAuthStore } from "store/useMasterAuthStore";
import { usePutTrackingSelectCancel } from "hooks/morning/usePutTrackingSelectCancel";
import Spinner from "components/Spinner";
import MorningConfirmDialog from "components/popup/MorningConfirmDialog";
import { usePutARequest } from "hooks/morning/usePutARequest";
import { usePostTrackingListExcel } from "hooks/morning/usePostTrackingListExcel";

const orderTitleBg = (type: string) => {
    let bg = "";
    switch (type) {
        case "오더접수":
            bg = "#5A5C63";
            break;
        case "픽업예약":
            bg = "#FF9200";
            break;
        case "픽업완료":
            bg = "#FF7B2E";
            break;
        case "배송중":
            bg = "#009632";
            break;
        case "배송완료":
            bg = "#1A75FF";
            break;
        case "접수취소":
            bg = "#EAEBEC";
            break;

        default:
            break;
    }
    return bg;
};

const TrackingList = ({
    data,
    onChangePage,
    onClose,
    filter,
    page,
    // setPage,
    isApp,
}: {
    data?: TrackingResponse;
    onChangePage?: (page: number) => void;
    onClose: () => void;
    filter?: TrackingRequest;
    page: number;
    isApp: boolean;
    // setPage: React.Dispatch<React.SetStateAction<number>>;
    // setPage: (page: number) => void;
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const responsive1200 = useMediaQuery(1200);
    const c_code = useMorningAuthStore(state => state.c_code ?? "");
    // const c_req_dept = useMorningAuthStore(state => state.c_req_dept);

    const isMaster = location.pathname.includes("master");
    const accessToken = useMorningAuthStore(state => state.accessToken ?? "");
    const isGuest = useMasterAuthStore(state => state.isGuest ?? true);
    const isLoggedIn = isMaster ? !isGuest : !!accessToken;

    // const [page, setPage] = useState<number>(1);
    const [trackingShow, setTrackingShow] = useState<boolean>(false);
    const [addPrintShow, setAddPrintShow] = useState<boolean>(false);
    const [selectedTrackingIdx, setSelectedTrackingIdx] = useState<string>("");
    const [addBLCount, setAddBLCount] = useState<string>("");
    const [addCount, setAddCount] = useState<string>("");
    // const [openedMemoIdx, setOpenedMemoIdx] = useState<string>("");
    // const [memo, setMemo] = useState<string>("");
    const [memoState, setMemoState] = useState<{
        bl_no: string;
        idx: string;
        memo: string;
    }>({
        bl_no: "",
        idx: "",
        memo: "",
    });
    const [trackingPop, setTrackingPop] = useState<boolean>(false);
    const [selectedBlNos, setSelectedBlNos] = useState<string[]>([]);
    const [isAllPrint, setIsAllPrint] = useState<boolean>(false);
    const [selectedChkBlNos, setSelectedChkBlNos] = useState<string[]>([]);
    const [countError, setCountError] = useState(false);

    const allBlNos = data?.orderList.filter(order => order.o_kind !== "접수취소").map(order => order.bl_no) || [];
    const allChkBlNos = data?.orderList.filter(order => order.o_kind !== "접수취소").flatMap(order => order.chk_bl_no) || [];

    const isAllSelected = allBlNos.length > 0 && allBlNos.every(bl => selectedBlNos.includes(bl));

    const { data: printData } = useGetTrackingAddPrint(selectedTrackingIdx);
    const { mutate: addPrint } = usePostTrackingAddPrint();
    const { mutate: addNextPrint } = usePostTrackingAddNextPrint();
    // const { mutate: memoTracking } = usePutTrackingMemo(() => {
    //     setOpenedMemoIdx("");
    //     onClose();
    // });
    const { mutate: updateARequest } = usePutARequest(() => {
        setMemoState({
            bl_no: "",
            idx: "",
            memo: "",
        });
        onClose();
    });
    const { mutate: selectCancel, isPending: isSelectCancelPending } = usePutTrackingSelectCancel();
    const { getExcel, isDownloading: isExcelDownloading } = usePostTrackingListExcel();
    // const { data: trackingData } = useGetTrackingPop(memoState.idx);

    const { data: infoData } = useGetMypageInfo({
        enabled: isLoggedIn,
    });

    const maxPage = data?.last_page ?? 1;
    const pageSize = 5;
    const currentGroup = Math.floor((page - 1) / pageSize);
    const startPage = currentGroup * pageSize + 1;
    const endPage = Math.min(startPage + pageSize - 1, maxPage);

    const handleSetPage = (pageNum: number) => {
        // setPage(pageNum);
        onChangePage?.(pageNum);
    };

    const handleAddPrint = () => {
        if (!addCount) {
            setCountError(true);
            return;
        }
        setCountError(false);
        if (addBLCount) {
            addNextPrint(
                {
                    pcmobile: "pc",
                    idx: Number(selectedTrackingIdx),
                    s_cnt: Number(addCount),
                    bl_cnt: Number(addBLCount),
                },
                {
                    onSuccess: res => {
                        navigate("/customer/online-order/complete", {
                            state: { data: res },
                        });
                    },
                },
            );
        } else {
            addPrint(
                {
                    pcmobile: "pc",
                    idx: Number(selectedTrackingIdx),
                    s_cnt: Number(addCount),
                },
                {
                    onSuccess: res => {
                        navigate("/customer/online-order/complete", {
                            state: { data: res },
                        });
                    },
                },
            );
        }
    };

    const handleMemo = (idx: number) => {
        // const payload = {
        //     idx: idx,
        //     memo: memo,
        // };
        // memoTracking(payload);

        if (memoState.idx !== idx.toString()) return;
        const payload = {
            idx: idx,
            a_request: memoState.memo,
        };
        updateARequest(payload);
    };

    useEffect(() => {
        setSelectedBlNos([]);
    }, [page]);

    return (
        <>
            {isSelectCancelPending && <Spinner />}
            <div className="bg-white justify-center w-full max-w-[1200px] p-10 rounded-2xl flex flex-col items-center mb-6 responsive1200:bg-[#F3F5F8] responsive1200:p-[0px_4%_40px] responsive1200:mb-0 responsive1200:rounded-none">
                <div className="py-[16px] flex justify-between w-full items-center responsive1200:items-end">
                    <div className="flex items-center gap-x-5">
                        <p>
                            총<span className="text-[#FF7B2E] mx-[3px]">{data?.total_count || 0}</span>건
                        </p>
                        {!responsive1200 && (
                            <MorningConfirmDialog
                                title="접수 취소"
                                content="접수를 취소 하시겠습니까?"
                                confirmButtonText="취소"
                                trigger={open => (
                                    <Button
                                        disabled={selectedChkBlNos.length === 0}
                                        className="disabled:opacity-70 disabled:cursor-not-allowed"
                                        onClick={open}
                                    //  onClick={() => {
                                    //      if (selectedChkBlNos.length === 0) {
                                    //          toast.error("항목을 선택해주세요.", toastErrorSyle);
                                    //          return;
                                    //      }

                                    //  }}
                                    >
                                        선택 운송장 접수 취소
                                    </Button>
                                )}
                                handleConfirm={() => {
                                    selectCancel(
                                        { bl_no: selectedBlNos },
                                        {
                                            onSuccess: () => {
                                                onClose(); // 리스트 get
                                                toast.success("접수취소 되었습니다.");
                                                setSelectedChkBlNos([]);
                                                setSelectedBlNos([]);
                                            },
                                            onError: (error: any) => {
                                                const message = error.message;
                                                toast.error(message, toastErrorSyle);
                                            },
                                        },
                                    );
                                }}
                            />
                        )}
                    </div>

                    {responsive1200 ? (
                        <div>
                            <Select value={"new"} onValueChange={value => { }}>
                                <SelectTrigger className="relative border-none shadow-none text-[#132E47] text-[15px] flex gap-[10px] focus:ring-[#FF7B2E]">
                                    <SelectValue placeholder="" />
                                    <ArrowDown />
                                </SelectTrigger>
                                <SelectContent className="bg-white">
                                    <SelectItem value="new">신규등록순</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                    ) : (
                        <div className="flex items-center gap-1">
                            <Button
                                className="underline flex gap-2"
                                onClick={() => {
                                    window.open("https://intriguing-dryer-881.notion.site/120a61a48d338056bbffe26a2216aecb", "_blank");
                                }}
                            >
                                <span className="w-0 h-0 border-t-[7px] border-b-[7px] border-l-[10px] border-t-transparent border-b-transparent border-l-current text-[#878A93]" />
                                프린트 설정 가이드(보기)
                            </Button>
                            <Button
                                onClick={() => {
                                    setTrackingPop(true);
                                    setIsAllPrint(true);
                                }}
                                color="new"
                            >
                                전체 운송장 출력
                            </Button>
                            <Button
                                onClick={() => {
                                    if (selectedChkBlNos.length === 0) {
                                        toast.error("항목을 선택해주세요.", toastErrorSyle);
                                        return;
                                    }
                                    setIsAllPrint(false);
                                    setTrackingPop(true);
                                }}
                                color="new"
                            >
                                선택 운송장 출력
                            </Button>
                        </div>
                    )}
                </div>

                {data && (data?.total_count || 0) > 0 ? (
                    <div className="w-full">
                        {responsive1200 ? (
                            <div className="flex flex-col gap-[12px]">
                                {data?.orderList.map((order, idx) => (
                                    <div
                                        key={idx}
                                        className={`text-[#1B1C1E] font-[500] shadow-[0px_0px_12px_0px_#CAD6DE99] bg-white rounded-[8px] overflow-hidden`}
                                    >
                                        <div
                                            className="flex justify-between px-[16px] py-[10px]"
                                            style={{ backgroundColor: orderTitleBg(order.o_kind) }}
                                        >
                                            <p className="font-[500] text-white">{order.o_kind}</p>
                                            <p className="font-[400] text-white">{order.w_date}</p>
                                        </div>
                                        <div className="px-[16px]">
                                            <div className="flex gap-[10px] items-center justify-center py-[12px] border-b border-dashed">
                                                <div
                                                    onClick={() => navigate(`/customer/tracking/detail?bl_no=${order.bl_no}`)}
                                                    className="text-[#1B1C1E] cursor-pointer underline font-[500] text-[20px]"
                                                >
                                                    {order.bl_no}
                                                </div>
                                                <div>
                                                    <p className="text-[#5A5C63]">{order.et_name}</p>
                                                </div>
                                            </div>
                                            <div className="flex py-[16px]">
                                                <div className="flex-1 items-cente text-center">{order.s_c_contact || "-"}</div>
                                                <div>
                                                    <RightArrow />
                                                </div>
                                                <div className="flex-1 text-center">{order.s_b_contact || "-"}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <table className="w-full mt-2.5">
                                <thead>
                                    <tr className="h-[80px] bg-[#F7F7F8] text-[#5a5c63]">
                                        <th className="font-[500] w-[60px] flex flex-col items-center h-[80px] justify-center">
                                            <CheckBox
                                                checked={isAllSelected}
                                                onChange={(checked: boolean) => {
                                                    if (checked) {
                                                        setSelectedBlNos(allBlNos);
                                                        setSelectedChkBlNos(allChkBlNos);
                                                    } else {
                                                        setSelectedBlNos([]);
                                                        setSelectedChkBlNos([]);
                                                    }
                                                }}
                                                offClassName="text-new"
                                            />
                                            <p>선택</p>
                                        </th>
                                        <th className="w-[60px] font-[500]">구분</th>
                                        <th className="w-[150px] font-[500]">
                                            운송장상세
                                            <br />
                                            (번호 클릭 / 터치)
                                        </th>
                                        <th className="w-[160px] font-[500]">상태 / 접수일자</th>
                                        <th className="w-[120px] font-[500] text-[#1b1c1e]">발송 및 지불</th>
                                        <th className="w-[153px] font-[500] text-[#1b1c1e]">출발지</th>
                                        <th>
                                            <RightArrow />
                                        </th>
                                        <th className="w-[153px] font-[500] text-[#1b1c1e]">도착지</th>
                                        <th className="w-[160px] font-[500]">수정/취소/추가</th>
                                        <th className="w-[80px] font-[500]">메모</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.orderList.map((order, idx) => (
                                        <tr key={idx} className="border-b text-center h-[73px] text-[#1B1C1E] font-[500]">
                                            <td className="flex items-center justify-center max-h-[73px]">
                                                {(order.o_kind === "오더접수" || order.o_kind === "픽업예약") && (
                                                    <CheckBox
                                                        checked={selectedBlNos.includes(order.bl_no)}
                                                        onChange={(checked: boolean) => {
                                                            setSelectedBlNos(prev =>
                                                                checked
                                                                    ? [...prev, order.bl_no]
                                                                    : prev.filter(item => item !== order.bl_no),
                                                            );
                                                            setSelectedChkBlNos(prev =>
                                                                checked
                                                                    ? [...prev, ...order.chk_bl_no]
                                                                    : prev.filter(item => !order.chk_bl_no.includes(item)),
                                                            );
                                                        }}
                                                        className="translate-y-1"
                                                        offClassName="text-new"
                                                    />
                                                )}
                                            </td>
                                            <td>{order.num}</td>
                                            <td
                                                onClick={() => navigate(`/customer/tracking/detail?bl_no=${order.bl_no}`)}
                                                className="text-[#003e9c] cursor-pointer underline font-[500]"
                                            >
                                                {order.bl_no}
                                            </td>
                                            <td>
                                                <p>{order.o_kind}</p>
                                                <p className="text-sm text-[#878a93]">{order.w_date}</p>
                                            </td>
                                            <td>
                                                <p>{order.et_name}</p>
                                            </td>
                                            <td>{order.s_c_contact || "-"}</td>
                                            <td>
                                                <RightArrow />
                                            </td>
                                            <td className="px-2 break-all">{order.s_b_contact || "-"}</td>
                                            <td>
                                                {order.cancelDate ? (
                                                    <p className="text-sm text-[#878a93]">{order.cancelDate}</p>
                                                ) : (
                                                    <div className="flex items-center justify-center gap-x-1">
                                                        {Array.isArray(order.modifyAddButton) &&
                                                            order.modifyAddButton.map((btn, i) => {
                                                                if (btn === "운송장 취소" || btn === "취소") {
                                                                    return (
                                                                        <MorningConfirmDialog
                                                                            key={i}
                                                                            title="접수 취소"
                                                                            content="접수를 취소 하시겠습니까?"
                                                                            confirmButtonText="취소"
                                                                            trigger={open => (
                                                                                <Button
                                                                                    key={i}
                                                                                    className="text-nowrap !px-[10px]"
                                                                                    onClick={open}
                                                                                >
                                                                                    {btn}
                                                                                </Button>
                                                                            )}
                                                                            handleConfirm={() => {
                                                                                const payload: string[] = [];
                                                                                payload.push(order.bl_no);

                                                                                selectCancel(
                                                                                    { bl_no: payload },
                                                                                    {
                                                                                        onSuccess: () => {
                                                                                            onClose(); // 리스트 get
                                                                                            toast.success("접수취소 되었습니다.");

                                                                                            setSelectedBlNos(prev =>
                                                                                                prev.filter(item => item !== order.bl_no),
                                                                                            );
                                                                                            setSelectedChkBlNos(prev =>
                                                                                                prev.filter(
                                                                                                    item => !order.chk_bl_no.includes(item),
                                                                                                ),
                                                                                            );
                                                                                        },
                                                                                        onError: (error: any) => {
                                                                                            const message = error.message;
                                                                                            toast.error(message, toastErrorSyle);
                                                                                        },
                                                                                    },
                                                                                );
                                                                            }}
                                                                        />
                                                                    );
                                                                }
                                                                return (
                                                                    <Button
                                                                        key={i}
                                                                        className="text-nowrap !px-[10px]"
                                                                        onClick={() => {
                                                                            if (btn === "수정") {
                                                                                setSelectedTrackingIdx(order.idx);
                                                                                setTrackingShow(true);
                                                                            } else if (btn === "추가출력") {
                                                                                setSelectedTrackingIdx(order.idx);
                                                                                setAddPrintShow(true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {btn}
                                                                    </Button>
                                                                );
                                                            })}
                                                    </div>
                                                )}
                                            </td>
                                            <td className="group flex h-[73px] items-center relative justify-center">
                                                {/* order.memo ||  */}
                                                {order.a_request.trim() !== "" ? (
                                                    <MemoOn
                                                        // onClick={() => {
                                                        //     setMemoState({
                                                        //         bl_no: order.bl_no,
                                                        //         idx: order.idx,
                                                        //         memo: order.a_request,
                                                        //     });
                                                        // }}
                                                        className="cursor-default"
                                                    />
                                                ) : (
                                                    <Memo
                                                        // onClick={() => {
                                                        //     setMemoState({
                                                        //         bl_no: order.bl_no,
                                                        //         idx: order.idx,
                                                        //         memo: order.a_request ?? "",
                                                        //     });
                                                        // }}
                                                        className="cursor-default"
                                                    />
                                                )}

                                                {memoState.idx === order.idx ? (
                                                    <div className="absolute top-14 right-0 mt-2 pb-3 z-50 w-[400px] px-5 bg-white rounded-2xl shadow-[0_0_16px_rgba(0,0,0,0.1)]">
                                                        <div className="flex justify-between items-center w-full py-4 ">
                                                            <p className="text-[20px] text-[#1B1C1E] font-[500]">메모 입력</p>
                                                            <Close
                                                                className="cursor-pointer"
                                                                onClick={() =>
                                                                    setMemoState({
                                                                        bl_no: "",
                                                                        idx: "",
                                                                        memo: "",
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                        <textarea
                                                            value={memoState.memo}
                                                            onChange={e => {
                                                                if (e.target.value.length <= 1000)
                                                                    setMemoState(prev => {
                                                                        return {
                                                                            ...prev,
                                                                            memo: e.target.value,
                                                                        };
                                                                    });
                                                            }}
                                                            placeholder="메모를 입력해주세요.&#13;&#10;해당 메모는 접수처에만 보입니다."
                                                            className="mt-2 focus:border-new focus:border outline-0 text-[16px] min-h-[144px] py-3 px-4 text-[#132E47] border resize-none w-full rounded-lg"
                                                        />
                                                        <p className="text-right text-xs text-[#5a5c63] mb-2 mr-1">
                                                            <span className="text-new">{memoState.memo.length.toLocaleString()}</span> /
                                                            1,000
                                                        </p>
                                                        <Button
                                                            onClick={() => handleMemo(Number(order.idx))}
                                                            size="L"
                                                            className="w-full border-none bg-[#f3f5f8] text-[#878a93]"
                                                        >
                                                            저장
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {order.a_request.trim() !== "" && (
                                                            <div className="hidden group-hover:block absolute top-full -translate-y-2 -translate-x-5 right-0 z-50 w-[400px] p-5 bg-white rounded-2xl shadow-[0_0_16px_rgba(0,0,0,0.1)]">
                                                                <pre className="text-[16px] text-[#1B1C1E] font-[500] whitespace-pre-wrap break-keep">
                                                                    {order.a_request}
                                                                </pre>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}

                        <div className="flex flex-wrap items-center gap-y-3 mt-6">
                            {/* 페이지네이션을 가운데 두기 위해 오른쪽 엑셀변환 버튼 영역과 같은 폭을 차지하는 빈 영역 */}
                            <div className="flex-1 responsive700:hidden" />
                            <div className="flex justify-center items-center gap-2 responsive700:w-full">
                                <button onClick={() => handleSetPage(1)}>
                                    <PageFirst />
                                </button>
                                <button onClick={() => handleSetPage(Math.max(1, page - 1))}>
                                    <PageBefore className="mr-7" />
                                </button>
                                {Array.from({ length: endPage - startPage + 1 }).map((_, i) => {
                                    const pageNum = startPage + i;
                                    return (
                                        <button
                                            key={pageNum}
                                            className={`px-3 py-1 rounded ${pageNum === page ? "bg-[#1B1C1E] text-white" : "text-black"}`}
                                            onClick={() => handleSetPage(pageNum)}
                                        >
                                            {pageNum}
                                        </button>
                                    );
                                })}
                                <button onClick={() => handleSetPage(Math.min(maxPage, page + 1))}>
                                    <PageBefore className="rotate-180 ml-7" />
                                </button>
                                <button onClick={() => handleSetPage(maxPage)}>
                                    <PageFirst className="rotate-180" />
                                </button>
                            </div>
                            <div className="flex-1 flex justify-end responsive700:w-full responsive700:flex-none">
                                <Button onClick={() => getExcel(filter ?? {})} disabled={isExcelDownloading} color="new">
                                    {isExcelDownloading ? "변환중..." : "엑셀변환"}
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="h-[500px] gap-7 flex flex-col items-center justify-center">
                        <Notice />
                        <p className="text-center text-[#878a93] text-[22px] font-semibold break-keep">
                            조회되는 운송장이 없습니다. <br /> 회원가입시 더 많은 서비스를 이용하실 수 있습니다.
                            <br /> 고객센터: 1566-0685
                        </p>
                    </div>
                )}
                {trackingShow && selectedTrackingIdx && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <ModifyTracking
                            done
                            idx={selectedTrackingIdx}
                            infoData={infoData}
                            onClose={() => {
                                setTrackingShow(false);
                                onClose();
                            }}
                        />
                    </div>
                )}
                {addPrintShow && selectedTrackingIdx && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="bg-white overflow-hidden rounded-2xl relative w-[440px]">
                            <div className="flex justify-between items-center w-full py-6 px-10">
                                <p className="text-2xl text-[#1B1C1E] font-bold">선택 추가출력</p>
                                <Close
                                    className="cursor-pointer"
                                    onClick={() => {
                                        setAddPrintShow(false);
                                        setCountError(false);
                                    }}
                                />
                            </div>
                            <div className="px-10 flex flex-col gap-2 mb-10">
                                <div className="w-full mb-4 py-4 bg-[#FEEEE5] flex items-center justify-center border border-new text-[#1B1C1E] text-lg rounded-2xl ">
                                    추가되는 수량만큼 청구 및 출력됩니다.
                                </div>
                                {(c_code === "0300001" || c_code === "0100348") && (
                                    <div className="flex items-center">
                                        <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>BL NO 수량</p>
                                        <Input
                                            value={addBLCount}
                                            onChange={e => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                const limited = value === "" ? "" : Math.min(Number(value), 100).toString();
                                                setAddBLCount(limited);
                                                setAddCount("1");
                                            }}
                                            className="w-full"
                                            unit="개"
                                            unitPadding="pr-9"
                                        />
                                    </div>
                                )}

                                <div className="flex items-center">
                                    <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>수량</p>
                                    <Input
                                        value={addCount}
                                        onChange={e => {
                                            if (!addBLCount) {
                                                const value = e.target.value.replace(/\D/g, "");
                                                const limited = value === "" ? "" : Math.min(Number(value), 100).toString();
                                                setAddCount(limited);
                                            }
                                            setCountError(false);
                                        }}
                                        className="w-full"
                                        unit="개"
                                        unitPadding="pr-9"
                                        error={countError}
                                    />
                                </div>
                                <div className="flex items-center h-[52px]">
                                    <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>접수자</p>
                                    <p className={`text-[18px] w-full`}>{printData?.a_company}</p>
                                </div>
                                <div className="flex items-center h-[52px]">
                                    <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>출발지</p>
                                    <p className={`text-[18px] w-full`}>{printData?.f_company}</p>
                                </div>
                                <div className="flex items-center h-[52px]">
                                    <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>도착지</p>
                                    <p className={`text-[18px] w-full`}>{printData?.t_company}</p>
                                </div>
                            </div>
                            <button
                                onClick={handleAddPrint}
                                className="w-full border-none font-bold bg-[#132e47] text-xl text-white min-h-[60px]"
                            >
                                운송장 추가 출력
                            </button>
                        </div>
                    </div>
                )}
                {trackingPop && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <PrintTracking
                            isAllPrint={isAllPrint}
                            filter={filter}
                            onClose={() => setTrackingPop(false)}
                            bl_no={selectedChkBlNos}
                        />
                    </div>
                )}
            </div>

            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
};

export default TrackingList;
